<template>
  <v-row v-if="newVersionReleased" justify="center">
    <v-dialog v-model="newVersionReleased" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Есть новая версия блога!</v-card-title>

        <v-card-text style="white-space: pre-line;">
          {{ newVersionComment }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="reloadApp">
            Перегрузить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  computed: {
    newVersionReleased() {
      if (this.$store.getters.getVersion.newversion) {
        return true
      } else {
        return false
      }
    },
    newVersionComment() {
      return (
        'А это значит, что ваша версия может работать некорректно и необходимо ПЕРЕГРУЗИТЬ страницу.\n\nТак а что в ней нового?\n\n' +
        this.$store.getters.getVersion.comment
      )
    }
  },
  methods: {
    reloadApp() {
      window.location.reload()
    }
  }
}
</script>

<style></style>
